import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CompanySurveyDetails.css";

export default function CompanySurveyDetails({ companyId }) {

  const [levels, setLevels] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [newLevel, setNewLevel] = useState("");
  const [newDepartment, setNewDepartment] = useState("");
  const [newUser, setNewUser] = useState({ email: "", role: "Admin" , password : "Random@123", company_fk : companyId,  });


  useEffect(() => {
    if (!companyId) return;
    loadData();
  }, [companyId]);


  const loadData = async () => {
    try {
      const base = process.env.REACT_APP_API_BASE_URL;
      const [lvl, dep, usr] = await Promise.all([
        axios.get(`${base}/superadmin/company/${companyId}/levels`),
        axios.get(`${base}/superadmin/company/${companyId}/departments`),
        axios.get(`${base}/superadmin/company/${companyId}/users`)
      ]);

      setLevels(Array.isArray(lvl.data) ? lvl.data.filter(l => l.name?.trim()) : []);
      setDepartments(Array.isArray(dep.data) ? dep.data.filter(d => d.name?.trim()) : []);
      setUsers(Array.isArray(usr.data) ? usr.data.filter(u => u.email?.trim()) : []);
    } catch (err) {
      console.error("Load error:", err);
    }
  };


  // ✅ ADD LEVEL (validation)
  const addLevel = async () => {

    const name = newLevel.trim();
    if (!name) {
      alert("⚠️ Level name cannot be empty");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/company/${companyId}/level`,
        { name }
      );
      setNewLevel("");
      loadData();
    } catch (err) {
      console.error(err);
      alert("Failed to add level");
    }
  };


  // ✅ ADD DEPARTMENT (validation)
  const addDepartment = async () => {

    const name = newDepartment.trim();
    if (!name) {
      alert("⚠️ Department name cannot be empty");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/company/${companyId}/department`,
        { name }
      );
      setNewDepartment("");
      loadData();
    } catch (err) {
      console.error(err);
      alert("Failed to add department");
    }
  };


  // ✅ ADD USER (validation)
  const addUser = async () => {

    const email = newUser.email.trim();

    if (!email) {
      alert("⚠️ Email is required");
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      alert("⚠️ Enter a valid email");
      return;
    }

    if (!newUser.role) {
      alert("⚠️ Role required");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/company/${companyId}/adduser`,
        { ...newUser, email }
      );
      setNewUser({ email: "", role: "Admin" , password : "Random@123", company_fk : companyId});
      loadData();
    } catch (err) {
      console.error(err);
      alert("Failed to add user");
    }
  };


  return (
    <div className="survey-admin-grid">

      {/* LEVELS */}
      <Panel
        title="🎓 Levels"
        items={levels}
        onAdd={addLevel}
        value={newLevel}
        onChange={(v) => setNewLevel(v)}
      />

      {/* DEPARTMENTS */}
      <Panel
        title="🏢 Departments"
        items={departments}
        onAdd={addDepartment}
        value={newDepartment}
        onChange={(v) => setNewDepartment(v)}
      />


      {/* USERS */}
      <div className="panel">
        <h3>👤 Users</h3>

        {users.length === 0 && (
          <div className="no-data">No users added</div>
        )}

        {users.map(u => (
          <div key={u.id} className="list-item">
            {u.email} <span className="tag">{u.role}</span>
          </div>
        ))}

        <div className="add-row">
          <input
            placeholder="Email"
            value={newUser.email}
            onChange={e => setNewUser({ ...newUser, email: e.target.value })}
          />

          <select
            value={newUser.role}
            onChange={e => setNewUser({ ...newUser, role: e.target.value })}
          >
            <option value="Admin">Admin</option>
            {/* <option value="user">User</option> */}
          </select>

             <button onClick={addUser} className="add-btn">
    ➕ Add User
  </button>
        </div>
      </div>

    </div>
  );
}



function Panel({ title, items = [], value, onAdd, onChange }) {
  return (
    <div className="panel">
      <h3>{title}</h3>

      <div className="scroll-area">
        {items.length === 0 && (
          <div className="no-data">No records</div>
        )}

        {items.map(i => (
          <div key={i.id || i.name} className="list-item">
            {i.name}
          </div>
        ))}
      </div>

      <div className="add-row">
        <input
          placeholder="Enter name"
          value={value}
          onChange={e => onChange(e.target.value)}
        />
        <button onClick={onAdd} className="add-btn">
          ➕ Add Row
        </button>
      </div>
    </div>
  );
}

